import { InlineLoader, Label } from 'cat-ecommerce-alloy';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from '../EditOrderInformationForm.module.scss';

const CustomerNumberLoader = () => {
  const [t] = useTranslation();

  return (
    <>
      <Label
        className={
          'text-md fw-normal u-color--DarkGray text-univers--bold text-uppercase line-height-125 mb-1'
        }
        showRequired
      >
        {t('FOOTER_ACCOUNT')}
      </Label>
      <InlineLoader
        className={cx(
          'd-flex align-items-center mb-lg-2 mb-3',
          styles['dropDownHeight']
        )}
      />
    </>
  );
};

export default CustomerNumberLoader;
